/**
 * Custom hook for extracting URL parameters
 * Specifically for extracting merchant public ID from QR code scan
 */

import { useSearchParams, useParams } from 'react-router-dom'

/**
 * Hook to extract merchant public ID from URL parameters
 * Supports both path parameters (/payment/:publicId) and query parameters (?public_id=...)
 * @returns The merchant public ID from URL or null
 */
export function useMerchantCodeFromUrl(): string | null {
  const [searchParams] = useSearchParams()
  const params = useParams()
  
  // Check path parameter first (e.g., /payment/JXNAJVFO25)
  if (params.publicId) {
    return params.publicId
  }
  
  // Then check query parameters
  return searchParams.get('public_id') || searchParams.get('merchant') || searchParams.get('code') || null
}

